// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1ejFZ","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1RFlv"};